import React, { useState } from 'react';

// Removed Ant Design imports
// Added CB component imports
import { CBButton, CBCard, CBInput, CBModal, CBRadioGroup, CBSelect } from '../../../core/components/cbd';
// Removed Option destructuring

function FullOrgEditModal({
	title,
	visible,
	handleOk,
	confirmLoading,
	handleCancel,
	// domain,
	// interval,
	// stripeId,
	// subId,
	// allowedDomains,
	// changeDomain,
	// changeStripeId
	organizationData,
	setOrgData
}) {
	//console.log(organizationData)
	
	const [domainType, setDomainType] = useState("google")
	const [allowedDomainName, setAllowedDomainName] = useState("")
	
	function handleChange(value){
			//console.log(`selected ${value}`);
			setDomainType(value)
	}

	function addDomain() {
		if(!organizationData.allowedDomains) {
			organizationData.allowedDomains = []
		}
		organizationData.allowedDomains.push(
			{
			name: allowedDomainName,
			domain: allowedDomainName,
			type: domainType
			})
		
		setAllowedDomainName('')
		setOrgData({...organizationData, allowedDomains: organizationData.allowedDomains
		})
	}


	// Prepare options for domain type select
	const domainTypeOptions = [
		{ label: 'Google', value: 'google' },
		{ label: 'MS', value: 'ms' },
		{ label: 'EWS', value: 'ews' },
	];
	// Prepare options for interval radio group
	const intervalLabels = ['Monthly', 'Yearly', '2022 Monthly', '2022 Yearly'];
	const intervalValues = ['monthly', 'yearly', '2022-monthly', '2022-yearly'];

	return (
		// Replaced Modal with CBModal
		<CBModal
			title={title}
			visible={visible}
			onPositiveClick={handleOk}
			confirmLoading={confirmLoading}
			onCancelClick={handleCancel}
			// positiveLabel="OK"
			// negativeLabel="Cancel"
		>
			<div className="space-y-4"> {/* Added spacing */}
				{/* Replaced Input with CBInput */}
				<CBInput
					label={'Org Id'}
					value={organizationData.orgId || ''} // Use value instead of defaultValue for controlled component
					onChange={val => {
						setOrgData({...organizationData, orgId: val, orgDomain: val}) // Assuming CBInput passes value directly
					}}
					disabled={!organizationData.new}
					className="pb-4"
				/>
				{/* Removed Domain Input */}
				<CBInput
					label={'Stripe Id'}
					value={organizationData.stripeId || ''}
					onChange={val => {
						setOrgData({...organizationData, stripeId: val})
					}}
					className="pb-4"
				/>
				<CBInput
					label={'Subscription Id'}
					value={organizationData.subId || ''}
					onChange={val => {
						setOrgData({...organizationData, subId: val})
					}}
					className="pb-4"
				/>
				<div> {/* Replaced div wrapper */}
					<span className="text-sm font-medium text-gray-700 mr-2">Billing Interval:</span> {/* Styled label */}
					{/* Replaced Radio.Group with CBRadioGroup */}
					<CBRadioGroup
						className="ml-1 mt-1 mb-1 inline-flex space-x-1" // Added styling for button-like appearance
						onChange={(index, value) => { // Adapt onChange signature
							setOrgData({...organizationData, orgInterval: value})
						}}
						selected={intervalValues.indexOf(organizationData.orgInterval || "monthly")} // Find index
						labels={intervalLabels}
						values={intervalValues}
						// Assuming CBRadioGroup can render buttons or needs specific styling
					/>
				</div>
				{/* Replaced Card with CBCard */}
				<CBCard title="Add Authed Domain" className="mt-4"> {/* Added margin */}
					<div className="space-y-2"> {/* Added spacing */}
						<CBInput
							placeholder="Enter domain name" // Added placeholder
							value={allowedDomainName}
							onChange={val => setAllowedDomainName(val.toLowerCase())}
						/>
						<div className="flex items-center space-x-2"> {/* Align Select and Button */}
							{/* Replaced Select with CBSelect */}
							<CBSelect
								labels={domainTypeOptions.map(opt => opt.label)}
								values={domainTypeOptions.map(opt => opt.value)}
								selected={domainType} // Use state variable
								onChange={handleChange} // Use existing handler
								style={{ width: 120 }}
							/>
							{/* Replaced Button with CBButton */}
							<CBButton onClick={addDomain} disabled={!allowedDomainName.trim()}>Add Domain</CBButton> {/* Disable if input is empty */}
						</div>
					</div>
					<div className="mt-4 text-sm font-medium text-gray-700">Authed Domains:</div>
					<div className="mt-2 space-y-1"> {/* Added spacing for domain list */}
						{organizationData.allowedDomains && organizationData.allowedDomains.map((e,i)=>
						{
							return (
								<div key={`${e.domain}-${e.type}-${i}`} className="flex justify-between items-center text-sm p-1 border-b border-gray-100"> {/* Added key and styling */}
									<span>{e.domain} - {e.type}</span>
									{/* Replaced Button with CBButton */}
									<CBButton
										onClick={event=> {
											var domains = organizationData.allowedDomains.filter(toFilter=> !(e.domain == toFilter.domain && e.type == toFilter.type))
											setOrgData({...organizationData,allowedDomains:domains})
										}}
										className="text-red-500 hover:text-red-700 text-xs px-1 py-0" // Minimal styling for 'x' button
									>
										x
									</CBButton>
								</div>
							)
						})}
						{(!organizationData.allowedDomains || organizationData.allowedDomains.length === 0) && (
							<div className="text-xs text-gray-500 italic">No domains added.</div> // Placeholder if list is empty
						)}
					</div>
				</CBCard>
			</div>
		</CBModal>
	);
}


export default FullOrgEditModal;